import PARENT from '../types.js';

const DATASET = `${PARENT}/DATASET`;

export const SET_SUMMARY = `${DATASET}/SET_SUMMARY`;
